"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var react_router_1 = require("react-router");
var __1 = require("../..");
var App_1 = require("../../App");
var color = "103, 90, 128";
var Header = function () {
    var _a, _b;
    var _c = (0, App_1.useEloise)(), siteConfig = _c.siteConfig, theme = _c.theme, logic = _c.logic;
    var location = (0, react_router_1.useLocation)();
    var _d = (0, react_1.useState)(siteConfig.defaultMode), siteMode = _d[0], setSiteMode = _d[1];
    (0, react_1.useEffect)(function () {
        var fetchSiteMode = function () { return __awaiter(void 0, void 0, void 0, function () {
            var locTest, test_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        locTest = localStorage.getItem("siteMode");
                        if (!locTest) return [3 /*break*/, 1];
                        setSiteMode(locTest);
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, logic.fb.docs.getUserDoc("")];
                    case 2:
                        test_1 = _a.sent();
                        if (test_1 && test_1.siteMode) {
                            setSiteMode(test_1.siteMode);
                            localStorage.setItem("siteMode", test_1.siteMode);
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchSiteMode();
    }, []);
    var pages = typeof siteConfig.pages === "function"
        ? siteConfig.pages(siteMode)
        : siteConfig.pages;
    var renderNavItems = function (pages) {
        return pages.map(function (page) {
            var _a;
            var pageUrl = (_a = page.url) !== null && _a !== void 0 ? _a : page.name;
            if (page.pages) {
                // If the page has nested pages, render a NavDropdown component
                return (react_1.default.createElement(__1.EloiseWidget, { key: "headerlink".concat(page.name), eloiseIntel: {
                        title: "Header Dropdown",
                        desc: "DropDown of Nav Options",
                    } },
                    react_1.default.createElement(react_bootstrap_1.NavDropdown, { title: page.name, id: page.name }, renderNavItems(page.pages))));
            }
            else {
                // Otherwise, render a Nav.Link component
                return (react_1.default.createElement(__1.EloiseWidget, { key: "headerlink".concat(page.name), eloiseIntel: {
                        title: "Nav Link",
                        desc: "Navigation Option",
                        purpose: "navigate to " + "/" + page.name,
                    } },
                    react_1.default.createElement(react_bootstrap_1.Nav.Link, { href: "/" + pageUrl, style: {
                            fontFamily: theme.font,
                            borderBottom: "3px solid ".concat(location.pathname !== "/".concat(pageUrl) ? "#fff" : theme.colors[0]),
                        } }, page.name)));
            }
        });
    };
    return (react_1.default.createElement(__1.EloiseWidget, { eloiseIntel: { title: "Header", desc: "Navigation for Application" } },
        react_1.default.createElement(react_bootstrap_1.Navbar, { style: (_a = theme.headerStyle) !== null && _a !== void 0 ? _a : {}, sticky: "top", expand: "lg", bg: siteConfig.headerTrans ? "" : "white" },
            react_1.default.createElement(react_bootstrap_1.Container, { className: "mx-1" },
                !theme.noHeaderLogo && (react_1.default.createElement(react_bootstrap_1.Navbar.Brand, { href: "/" },
                    react_1.default.createElement("img", { src: siteConfig.logo, width: (_b = siteConfig.logoWidth) !== null && _b !== void 0 ? _b : "50", height: "auto", className: "d-inline-block align-top", alt: "React Bootstrap logo" }))),
                !theme.noHeaderText && (react_1.default.createElement(react_bootstrap_1.Navbar.Brand, { href: "/", style: { fontFamily: theme.font } }, siteConfig.name)),
                react_1.default.createElement(react_bootstrap_1.Navbar.Toggle, { "aria-controls": "basic-navbar-nav" }),
                react_1.default.createElement(react_bootstrap_1.Navbar.Collapse, { id: "basic-navbar-nav" },
                    react_1.default.createElement(react_bootstrap_1.Nav, { className: "me-auto" }, renderNavItems(pages.slice(1).filter(function (page) { return !page.hidden; }))))))));
};
exports.default = Header;
